export var ACTION_TYPE = {
    Reset: 'reset',
    ResetMachine: 'resetMachine'
};
